import { columns } from "./columns";
const { favorite, industry, totalVisits, uniqueVisitors, totalVisitsChange, uniqueVisitorsChange } = columns;

const width = `calc( (100% - ${favorite.width}px - ${industry.width}px) / 4)`;

export const defaultColumns = [
    favorite,
    industry,
    { ...totalVisits, width },
    { ...totalVisitsChange, width },
    { ...uniqueVisitors, width },
    { ...uniqueVisitorsChange, width },
];
